import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCyberDenial = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M14.777 6.224a31 31 0 1 1 34.446 51.552A31 31 0 0 1 14.777 6.224M32 3a29 29 0 1 0 0 58 29 29 0 0 0 0-58m-.002 5H32a23.9 23.9 0 0 1 14.194 4.697 1 1 0 0 1 .112 1.51l-32.1 32.1a1 1 0 0 1-1.513-.116A24 24 0 0 1 31.998 8m12.053 5.635A21.9 21.9 0 0 0 32 10 22 22 0 0 0 13.64 44.046zm6.525 3.768a1 1 0 0 1 .73.406A24 24 0 0 1 32.002 56H32a23.9 23.9 0 0 1-14.194-4.696 1 1 0 0 1-.112-1.511l32.1-32.1a1 1 0 0 1 .783-.29M19.95 50.365A21.9 21.9 0 0 0 32 54a22 22 0 0 0 18.36-34.046z",
		clipRule: "evenodd"
	})
});
export default SvgCyberDenial;
